/**
 * Intermediate URL segments often have no route (e.g. …/work-orders/tickets).
 * Map them to a real page, or null to render a non-clickable crumb.
 */
const BREADCRUMB_HREF_ALIASES: Record<string, string | null> = {
  '/': '/home',
  '/account': '/account/profile',
  '/maintenance': '/maintenance/preventive',
  '/maintenance/work-orders': '/maintenance/work-orders/kanban',
  '/maintenance/work-orders/tickets': '/maintenance/work-orders/kanban',
  '/sla': '/sla/landlords',
};

const BREADCRUMB_TITLE_OVERRIDES: Record<string, string> = {
  account: 'Account',
  profile: 'Profile',
  people: 'Users',
  landlords: 'Landlords',
  oems: 'O&Ms',
  kms: 'Knowledge Assistant',
  session: 'Sessions',
  sessions: 'Sessions',
};

const ASSET_STATIC_SEGMENTS = new Set(['import', 'custom-fields']);

export function resolveBreadcrumbHref(href: string): string | null {
  if (Object.prototype.hasOwnProperty.call(BREADCRUMB_HREF_ALIASES, href)) {
    return BREADCRUMB_HREF_ALIASES[href] ?? null;
  }
  return href;
}

export function isWorkOrderTicketDetailPath(segments: string[]): boolean {
  return (
    segments.length === 4 &&
    segments[0] === 'maintenance' &&
    segments[1] === 'work-orders' &&
    segments[2] === 'tickets'
  );
}

export function isAssetDetailPath(segments: string[]): boolean {
  return (
    segments.length === 2 &&
    segments[0] === 'assets' &&
    !ASSET_STATIC_SEGMENTS.has(segments[1])
  );
}

export function toBreadcrumbTitle(str: string): string {
  const lower = str.toLowerCase();
  if (BREADCRUMB_TITLE_OVERRIDES[lower]) {
    return BREADCRUMB_TITLE_OVERRIDES[lower];
  }
  return str.replace(/[-_]/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}
